export const FETCH_TASK_TYPE = "FETCH_TASK_TYPE";
export const FETCH_TASK_TYPE_SUCCESS = "FETCH_TASK_TYPE_SUCCESS";
export const FETCH_TASK_TYPE_FAILURE = "FETCH_TASK_TYPE_FAILURE";

export const SAVE_TASK_TYPE = "SAVE_TASK_TYPE";
export const SAVE_TASK_TYPE_SUCCESS = "SAVE_TASK_TYPE_SUCCESS";
export const SAVE_TASK_TYPE_FAILURE = "SAVE_TASK_TYPE_FAILURE";

export const CHANGE_TASK_TYPE_STATUS = "CHANGE_TASK_TYPE_STATUS";
export const CHANGE_TASK_TYPE_STATUS_SUCCESS = "CHANGE_TASK_TYPE_STATUS_SUCCESS";
export const CHANGE_TASK_TYPE_STATUS_FAILURE = "CHANGE_TASK_TYPE_STATUS_FAILURE";

export const FETCH_TASK_TYPE_MODE = "FETCH_TASK_TYPE_MODE";
export const FETCH_TASK_TYPE_MODE_SUCCESS = "FETCH_TASK_TYPE_MODE_SUCCESS";
export const FETCH_TASK_TYPE_MODE_FAILURE = "FETCH_TASK_TYPE_MODE_FAILURE";
export const FETCH_TASK_TYPE_MODE_CLEAR = "FETCH_TASK_TYPE_MODE_CLEAR";
  
